"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var collection_1 = require("../utils/collection");
var typeChecks_1 = require("../utils/typeChecks");
var Transform_1 = require("../query/transform/Transform");
var _1 = require(".");
var RebaseHelper = /** @class */ (function () {
    function RebaseHelper(options, translationHelper) {
        this.options = options;
        this.translationHelper = translationHelper || new _1.TranslationHelper({}, {});
    }
    /**
     * Check whether rebase should be applied
     * @param collection
     */
    RebaseHelper.prototype.mustPerformRebase = function (collection) {
        var _a = this.options, enabled = _a.enabled, series = _a.series;
        return enabled && !typeChecks_1.isNullOrEmpty(series) && !typeChecks_1.isNullOrEmpty(collection);
    };
    /**
     * Apply rebase to a data collection
     * @param collection
     */
    RebaseHelper.prototype.rebase = function (collection) {
        var _this = this;
        var _a = this.options, series = _a.series, postTransforms = _a.postTransforms;
        if (this.mustPerformRebase(collection)) {
            collection = collection_1.sortByDate(collection, function (item) { return item.date; });
            collection = this.applyInceptionInjection(collection);
            series.forEach(function (seriesInstance) {
                collection = _this.orchestrateSeries(collection, seriesInstance);
                collection = _this.rebaseSeries(collection, seriesInstance);
                if (!typeChecks_1.isNullOrEmpty(postTransforms)) {
                    collection = _this.postTransforms(collection, seriesInstance, postTransforms);
                }
            });
        }
        return collection;
    };
    RebaseHelper.prototype.applyInceptionInjection = function (collection) {
        var _a = this.options, inceptionInjection = _a.inceptionInjection, series = _a.series;
        if (inceptionInjection) {
            if (!series.some(function (serie) { return serie.type === 'value'; })) {
                var enabled = inceptionInjection.enabled, forceUniqueInceptionRecord = inceptionInjection.forceUniqueInceptionRecord, inceptionDate_1 = inceptionInjection.inceptionDate;
                if (enabled) {
                    var mustInject = !forceUniqueInceptionRecord || !collection.some(function (item) { return item.date === inceptionDate_1; });
                    if (mustInject) {
                        // Get the first item's date prop to determine the data type
                        var itemDate = collection[0].date;
                        var typedInceptionDate = void 0;
                        switch (typeof itemDate) {
                            case 'number':
                                typedInceptionDate = new Date(inceptionDate_1).getTime();
                                break;
                            case 'object':
                                // Check if date object
                                if (typeof itemDate.getDate === 'function') {
                                    typedInceptionDate = new Date(inceptionDate_1);
                                }
                                break;
                            case 'string':
                            default:
                                typedInceptionDate = inceptionDate_1;
                                break;
                        }
                        collection.unshift({ date: typedInceptionDate });
                    }
                }
            }
            else {
                console.warn('"Inception injection" configuration is not supported with "value" type series');
            }
        }
        return collection;
    };
    /**
     * Convert series values to change values if the series type is 'value'
     * Apply the value modifier if one exists
     * @param collection
     * @param series
     */
    RebaseHelper.prototype.orchestrateSeries = function (collection, series) {
        var key = series.key, valueModifier = series.valueModifier, _a = series.hideNoData, hideNoData = _a === void 0 ? false : _a, _b = series.type, type = _b === void 0 ? 'change' : _b;
        if (!typeChecks_1.isNullOrEmpty(collection)) {
            if (type === 'value' && valueModifier) {
                console.warn("\"valueModifier\" configuration cannot be used with \"value\" type series ~ data key \"" + key + "\" is of type \"value\"");
            }
            for (var i = collection.length - 1; i > 0; i--) {
                var currentValue = collection[i][key];
                var previousValue = collection[i - 1][key];
                if (type === 'value' && previousValue !== 0) {
                    collection[i][key] = (currentValue / previousValue) - 1;
                }
                else if (!typeChecks_1.isNullOrUndefined(valueModifier)) {
                    collection[i][key] = this.applyModifier(currentValue, valueModifier, hideNoData);
                }
            }
        }
        return collection;
    };
    /**
     * Run the base logic through the values in a series
     * @param collection
     * @param key
     */
    RebaseHelper.prototype.rebaseSeries = function (collection, series) {
        var key = series.key, _a = series.hideNoData, hideNoData = _a === void 0 ? false : _a;
        var startValue = series.startValue || this.options.startValue || 100;
        var startIndex = hideNoData ? this.seriesStartIndex(collection, series) : 1;
        if (!typeChecks_1.isNullOrEmpty(collection)) {
            collection[startIndex - 1][key] = startValue;
            for (var i = startIndex; i < collection.length; i++) {
                var previous = collection[i - 1];
                var delta = collection[i];
                if (Number.isNaN(delta[key]) || typeChecks_1.isNullOrUndefined(delta[key])) {
                    delta[key] = previous[key];
                }
                else {
                    var deltaValue = delta[key];
                    delta[key] = previous[key] * (1 + deltaValue);
                }
            }
        }
        return collection;
    };
    /**
     * Apply the given value modifier
     * @param rawValue
     * @param valueModifier
     */
    RebaseHelper.prototype.applyModifier = function (rawValue, valueModifier, hideNoData) {
        if (valueModifier) {
            if (valueModifier === 'divideBy100') {
                return hideNoData && !typeChecks_1.isNumber(rawValue) ? null : (rawValue / 100);
            }
            if (valueModifier === 'multiplyBy100') {
                return hideNoData && !typeChecks_1.isNumber(rawValue) ? null : (rawValue * 100);
            }
            return valueModifier(rawValue);
        }
        return rawValue;
    };
    RebaseHelper.prototype.seriesStartIndex = function (collection, series) {
        var key = series.key;
        for (var i = 0; i < collection.length; i++) {
            if (typeChecks_1.isNumber(collection[i][key])) {
                return i;
            }
        }
    };
    RebaseHelper.prototype.postTransforms = function (collection, series, transformOptions) {
        var key = series.key;
        if (!typeChecks_1.isNullOrEmpty(collection)) {
            for (var i = 0; i < collection.length; i++) {
                for (var _i = 0, transformOptions_1 = transformOptions; _i < transformOptions_1.length; _i++) {
                    var transformOption = transformOptions_1[_i];
                    var transform = new Transform_1.Transform(transformOption, this.translationHelper);
                    collection[i][key] = transform.execute(collection[i][key], { queryOptionsType: 'none' }, {});
                }
            }
        }
        return collection;
    };
    return RebaseHelper;
}());
exports.RebaseHelper = RebaseHelper;
//# sourceMappingURL=RebaseHelper.js.map